// import Swiper JS
import Swiper from 'swiper';
import { Autoplay, FreeMode } from 'swiper/modules';
// import $ from 'jquery';

// Swiper gebruiken voor de slider
window.addEventListener('DOMContentLoaded', function () {
    const elements = document.querySelectorAll('.juist-usps-block .swiper');
    elements.forEach(element => {
        const swiper = new Swiper(element, {
            modules: [Autoplay, FreeMode],
            autoplay: true,
            slidesPerView: 1,
            spaceBetween: 30,
            breakpoints: {
                768: {
                    slidesPerView: 2,
                },
                1200: {
                    slidesPerView: 3,
                }
            },
        });
    });
});
